const languageCodes = {
  EN: 'en',
  EL: 'el',
  AR: 'ar'
}

const supportedLanguageCodes = new Set([languageCodes.EN, languageCodes.EL, languageCodes.AR])

const defaultLanguageCode = languageCodes.EN

const languagesData = {
  shortTitle: {
    [languageCodes.EN]: 'EN',
    [languageCodes.EL]: 'ΕΛ',
    [languageCodes.AR]: 'اَلْعَرَبِيَّةُ'
  },
  longTitle: {
    [languageCodes.EN]: 'English',
    [languageCodes.EL]: 'Ελληνικά',
    [languageCodes.AR]: 'اَلْعَرَبِيَّةُ'
  },
}

module.exports = {
  languageCodes,
  supportedLanguageCodes,
  defaultLanguageCode,
  languagesData,
}
